/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1EditIcon16Solid = forwardRef('People1EditIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M9.433 9.074c.568.067.753.74.349 1.144L6.22 13.78a.75.75 0 0 1-.53.22H3.4c-.773 0-1.425-.637-1.263-1.393C2.857 9.24 6.235 9 8 9c.409 0 .905.013 1.433.074Z" }),
        React.createElement("path", { d: "M8 14.414V15.5a.5.5 0 0 0 .5.5h1.086a1 1 0 0 0 .707-.293l3.804-3.804-2-2-3.804 3.804a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m15.682 10.318-.878.878-2-2 .878-.878a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 1 0 1.414Z" })));
});
